import { Mail, MapPin, Globe, ChevronRight } from "lucide-react";
import { KONTAKT_EMAIL, SIDLO } from "./LandingHead";
import { lokalizujMapu } from "../../../features/mapEmbed";
import "./Kontakt.scss";

/**
 * Obchodny kontakt pre zaujemcu: e-mail a sidlo v Kosiciach. Podpora sem
 * zamerne nepatri -- tu riesia az prihlaseni pouzivatelia v aplikacii.
 *
 * Vzhlad je prevzaty z kontaktu prevadzky (screens/KontaktPage): biela karta,
 * udaje s ikonou a popiskom, vedla skutocna Google mapa. Triedy maju prefix
 * landing-, lebo .kontakt__* uz pouziva KontaktPage a CSS je v builde spolocne.
 */
const ADRESA = `${SIDLO.ulica}, ${SIDLO.psc} ${SIDLO.mesto}`;

const MAPA_URL = lokalizujMapu(
  `https://maps.google.com/maps?q=${encodeURIComponent(`INVER spol. s r.o., ${ADRESA}`)}&z=15&output=embed`
);

function Kontakt() {
  return (
    <section className="landing__section landing-kontakt" id="kontakt">
      <h2 className="landing__h2">Kontakt</h2>
      <p className="landing__lead">
        Máte otázku k systému? Napíšte nám.
      </p>

      <div className="landing-kontakt__grid">
        <div className="landing-kontakt__karta">
          <ul className="landing-kontakt__udaje">
            <li className="landing-kontakt__udaj">
              <span className="landing-kontakt__ikona"><Mail size={19} aria-hidden="true" /></span>
              <div>
                <span className="landing-kontakt__label">E-mail</span>
                <a className="landing-kontakt__hodnota landing-kontakt__odkaz" href={`mailto:${KONTAKT_EMAIL}`}>
                  {KONTAKT_EMAIL}
                </a>
              </div>
            </li>
            <li className="landing-kontakt__udaj">
              <span className="landing-kontakt__ikona"><MapPin size={19} aria-hidden="true" /></span>
              <div>
                <span className="landing-kontakt__label">Sídlo</span>
                <span className="landing-kontakt__hodnota">INVER spol. s r.o.</span>
                <span className="landing-kontakt__pod">{ADRESA}</span>
              </div>
            </li>
            <li className="landing-kontakt__udaj">
              <span className="landing-kontakt__ikona"><Globe size={19} aria-hidden="true" /></span>
              <div>
                <span className="landing-kontakt__label">Web prevádzkovateľa</span>
                <a
                  className="landing-kontakt__hodnota landing-kontakt__odkaz"
                  href="https://www.inver.sk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.inver.sk
                </a>
              </div>
            </li>
          </ul>

          <p className="landing-kontakt__poznamka">
            Ste z Košíc alebo okolia? Pokojne sa ozvite.
          </p>

          <a className="landing__btn landing__btn--primary landing-kontakt__btn" href={`mailto:${KONTAKT_EMAIL}`}>
            Napísať e-mail <ChevronRight size={18} aria-hidden="true" />
          </a>
        </div>

        <div className="landing-kontakt__mapa">
          <iframe
            title={`Mapa – ${ADRESA}`}
            src={MAPA_URL}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}

export default Kontakt;
